var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"resize",rawName:"v-resize"}],ref:"footer",staticClass:"footer transitions",on:{"resize":_vm.onResize}})
}
var staticRenderFns = []

export { render, staticRenderFns }